import script from "./nav-bar-show-status-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-bar-show-status-bar.vue?vue&type=script&setup=true&lang=ts"

import "./nav-bar-show-status-bar.vue?vue&type=style&index=0&id=2d8d78cd&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8d78cd"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
